<template>
  <div v-if="appVersion" class="app-version">v{{ appVersion }}</div>
</template>

<script setup lan="ts">
import { appVersion } from "@/version";
</script>

<style scoped>
.app-version {
  position: fixed;
  bottom: 10px;
  left: 10px;
  font-size: 8px;
  color: #999;
}
</style>
